import { DataSender } from '../loaders'
/**
* NewEventModal
*/

class NewEventModal {
    constructor(target, eventId, callback) {
        this.target = target;

        this.callback = (callback) ? callback : null;
        this.locked = false;
        this.eventId = eventId;

        this.loadModal();
    }

    loadModal() {
        var that = this;

        this.target.html('<div class="activity-indicator gray"></div>');
        this.target.show();
        
        new DataSender({
            data: {id: this.eventId},
            url: '/new-event/load/',

            success: function(data) {
                if(data.status) {
                    that.target.html(data.html);
                    that.initModal();
                }
            },

            error: function() {
                that.closeModal();
            }
        });
    }

    initModal() {
        var that = this;

        that.target.on('hidden.bs.modal', function () {
            that.closeModal();
        });
        $('.close').on('click',function(){
            that.closeModal();
        })

    }

    closeModal() {
        this.target.hide();
        this.target.html('');
        
        if(this.callback) {
            this.callback();
        }
        
        window.activeModalInstance = null;
    }
}

export { NewEventModal }
